<section>
  <div class="overlay-status-for-mobile" 
        [ngClass]="{'hidden': !showMobileOverlay, 'flex': showMobileOverlay}" 
        (click)="$event.stopPropagation()">
        <div class="close-mobile-status" (click)="closeOverlayStatus()">
          <img src="assets/img/kanban-edit-overlay/exit-subtask.svg" alt="">
        </div>
    <div class="mobile-status-overlay">
      <button [ngClass]="{'chosen-one': task.status === 'to do'}" (click)="setStatus('to do'); $event.stopPropagation()">To do</button>
      <button [ngClass]="{'chosen-one': task.status === 'in progress'}" (click)="setStatus('in progress'); $event.stopPropagation()">in progress</button>
      <button [ngClass]="{'chosen-one': task.status === 'await feedback'}" (click)="setStatus('await feedback'); $event.stopPropagation()">Await feedback</button>
      <button [ngClass]="{'chosen-one': task.status === 'done'}" (click)="setStatus('done'); $event.stopPropagation()">Done</button>
    </div>
  </div>
  <div class="testcontainer">
    <div class="category-moveto">
      <div class="category {{task.category?.toLowerCase()?.replace(' ', '-')}}">{{task.category}} </div>
      <div class="move-to-mobile" (click)="openMobileOverlay($event)">
        <img src="assets/img/kanban-board/mobileMoveToButton.png" alt="">
      </div>
    </div>
    <div class="title">
      <h4>{{task.title}}</h4>
    </div>
    <div class="description">
      {{task.description}}
    </div>
    
    @if (task.subTaskFillTest.length > 1) {
      <div class="subtask-progress-row">
        <div class="subtask-progress-bar">
          <div class="subtask-progress-bar-fill" [style.width.%]="subtaskProgress"></div>
        </div>
        <div class="subtask-progress-label">
          {{completedSubtasks}}/{{totalSubtasks}} Subtasks
        </div>
      </div>
    }


    
    <div class="user-content">
      <div class="user-area">
        @for (user of task.assignedTo?.slice(0, 3) || []; track $index) {
          <div class="user-details">
            <div class="user initials" [style.background]="user.color">{{ user.initials }}</div>
          </div>
        }
        @if ((task.assignedTo?.length || 0) > 3) {
          <div class="more-users">+{{ (task.assignedTo?.length || 0) - 3 }}</div>
        }
      </div>

      <div class="user-priority">

        <div [class]="task.priority.toLowerCase()"></div>
      </div>

    </div>
  </div>
</section>